module.exports = __webpack_public_path__ + "static/tablet-footer-smh-bd001de8b2af6720ee984cc03da7a6f2.jpg";